module.exports = __webpack_public_path__ + "img/header-13.def0ea01.png";